export const TEXT_PRIMARY_TITLE = {
    class: 'text-h1 text-primary-darker'
};

export const TEXT_SECONDARY_TITLE = {
    class: 'text-h2 text-primary-darker'
};

export const TEXT_SECONDARY_TITLE_LIGHT = {
    class: 'text-h2 text-weight-regular text-primary-darker'
};

export const TEXT_TERTIARY_TITLE = {
    class: 'text-h3 text-primary-darker'
};

export const TEXT_QUATERNARY_TITLE = {
    class: 'text-h4 text-primary-darker'
};

export const TEXT_HEADER_BODY = {
    class: 'text-body2 text-primary-darker'
};

export const TEXT_HEADER_BODY_NEGATIVE = {
    class: 'text-body2 text-negative'
};

export const TEXT_CONTENT_BODY = {
    class: 'text-body1 text-primary-darker'
};
export const TEXT_CONTENT_BODY_NEGATIVE = {
    class: 'text-body1 text-negative'
};

export const TEXT_CONTENT_BODY3 = {
    class: 'text-body3 text-primary-darker'
};

export const TEXT_SECONDARY_BODY = {
    class: 'text-body1 text-grey-dark'
};

export const TEXT_SMALL_BODY = {
    class: 'text-body2 text-grey-dark'
};

export const TEXT_SMALLER_BODY = {
    class: 'text-body3 text-grey-dark'
};

export const TEXT_LIGHT_BODY = {
    class: 'text-body2 text-grey'
};

export const TEXT_LIGHT_TITLE = {
    class: 'text-h1 text-weight-regular text-primary-darker'
};

export const TEXT_OVERLINE = {
    class: 'text-overline text-grey'
};

export const TEXT_PRIMARY_OVERLINE = {
    class: 'text-overline text-primary-darker'
};

export const TEXT_CAPTION = {
    class: 'text-caption text-grey-dark'
};

export const TEXT_CARD_TITLE = {
    class: 'text-body1 text-primary-darker ellipsis-2-lines'
};

export const TEXT_CARD_BODY = {
    class: 'text-body2 text-primary-darker'
};

export const TEXT_CARD_CAPTION = {
    class: 'text-body2 text-grey-dark'
};

export const TEXT_CARD_PLACEHOLDER = {
    class: 'ellipsis text-body2 text-grey'
};

export const TEXT_PLACEHOLDER = {
    class: 'text-body2 text-grey-dark'
};

export const TEXT_FORM_FIELD_LABEL = {
    class: 'text-body2 text-primary-darker'
};

export const TEXT_LINK = {
    class: 'text-link text-body1'
};

export const TEXT_LINK_SM = {
    class: 'text-link text-body2'
};

export const TEXT_FONT_WEIGHT = {
    class: 'text-body2 text-weight-medium text-primary-darker'
};

export const TEXT_LINK_SM_UNDERLINED = {
    class: 'text-body2 text-underlined'
};
